import React from "react";

const Else = () => {
  return (
    <div>
      <h1>Else Component</h1>
      <p>Content for Else goes here...</p>
    </div>
  );
};

export default Else;
